import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { getStatesInSelectedCountry } from '../../../address/utils';
import FormField from '../FormField';
import MobileDropdownDrawer from '@app/components/common/MobileDropdownDrawer';

const StateField = ({ isStateRequired, countries, withSearchbox = false }) => {
  const [t] = useTranslation();
  const { watch } = useFormContext();

  const countryName = watch('country');

  const statesOrProvinces = getStatesInSelectedCountry(countries, countryName);

  const stateDisplayOptions = statesOrProvinces.map(
    ({ displayName }) => displayName
  );

  return statesOrProvinces && statesOrProvinces.length > 0 ? (
    <MobileDropdownDrawer
      label={t('CAT_EMAIL_STATE')}
      fieldId="state"
      dataTestId="state"
      items={stateDisplayOptions}
      required={isStateRequired}
      requiredValidationMessage={t('1626_FIELD_REQUIRED_ERROR')}
      withSearch={withSearchbox}
      searchPlaceHolder={t('SEARCH_STATE_PROVINCE')}
    />
  ) : (
    <FormField
      fieldId="state"
      required={isStateRequired}
      label={t('CAT_EMAIL_STATE')}
    />
  );
};

StateField.propTypes = {
  isStateRequired: PropTypes.bool,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      displayName: PropTypes.string.isRequired,
      states: PropTypes.arrayOf(
        PropTypes.shape({
          code: PropTypes.string,
          displayName: PropTypes.string
        })
      )
    })
  ),
  withSearchbox: PropTypes.bool
};

export default StateField;
